<template>
  <div>
    <ContentSectionLoader v-if="!loaded" />
    <Transition name="fade">
      <BaseTabInterface
        v-show="loaded"
        :tabs="availableTabs"
        :initial-tab="availableTabs[0]"
      >
        <div
          slot-scope="{ tabs, activeTab, changeActiveTab }"
          class="tabs"
        >
          <ul class="tabs__tab md:inline-flex">
            <BaseTab
              v-for="(tab, index) in tabs"
              :key="tab.slug"
            >
              <li
                class="w-full md:w-auto"
                :class="{ 'current': activeTab === tab.slug }"
              >
                <a
                  :id="`tab-${tab.slug}`"
                  :aria-selected="activeTab === tab.slug"
                  @click="changeActiveTab(tab.slug)"
                  v-text="`${index + 1}. ${tab.title}`"
                />
              </li>
            </BaseTab>
          </ul>
          <div class="tabs__tab_content py-8">
            <BaseTabContent
              :active-tab="activeTab"
              tab-id="discuss"
            >
              <DiscussPane
                v-model="form"
                :loaded="postLoaded"
                @categoriesLoaded="categoriesLoaded = true"
                @changeActiveTab="(newTab) => changeActiveTab(newTab)"
              />
            </BaseTabContent>
            <BaseTabContent
              :active-tab="activeTab"
              tab-id="documents"
            >
              <DocumentPane
                ref="documents"
                v-model="form"
                @nextClicked="(newTab) => changeActiveTab('publish')"
                @uploadHasCompleted="redirect"
                @uploadHasErrored=" () => changeActiveTab('documents')"
              />
            </BaseTabContent>
            <BaseTabContent
              :active-tab="activeTab"
              tab-id="publish"
            >
              <PreviewPane
                v-model="form"
                @changeActiveTab="(newTab) => changeActiveTab(newTab)"
                @send="send"
              />
            </BaseTabContent>
          </div>
        </div>
      </BaseTabInterface>
    </Transition>
  </div>
</template>

<script type="text/babel">
import URI from 'urijs'
import { mapActions, mapState } from 'vuex'
import DiscussPane from './DiscussPane'
import PreviewPane from './PreviewPane'
import DocumentPane from 'Base/Resources/assets/js/components/DocumentPane'
import Form from 'Base/Resources/assets/js/MUMForm'
import BaseTab from 'Base/Resources/assets/js/components/BaseTab'
import BaseTabContent from 'Base/Resources/assets/js/components/BaseTabContent'

export default {
  name: 'DiscussionPostForm',
  components: {
    BaseTab,
    DocumentPane,
    PreviewPane,
    BaseTabContent,
    DiscussPane,
  },
  props: {
    discussionPostUuid: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      form: new Form({
        uuid: false,
        exists: false,
        filesInQueue: false,
        uploadingDocuments: false,
        currentUploadCount: false,
        totalUploadCount: false,
        existingDocuments: false,
        documentsToRemove: [],
        title: '',
        body: '',
        category: {
          uuid: null,
        },
      }),
      categoriesLoaded: false,
      postLoaded: false,
      availableTabs: [
        {
          title: 'Discuss',
          slug: 'discuss',
        },
        {
          title: 'Documents',
          slug: 'documents',
        },
        {
          title: 'Publish',
          slug: 'publish',
        },
      ],
      redirectUri: '',
    }
  },
  computed: {
    ...mapState({
      post: state => state.discussion.post,
    }),
    loaded() {
      if (this.discussionPostUuid) {
        return this.postLoaded && this.categoriesLoaded
      }

      return this.categoriesLoaded
    },
  },
  async mounted() {
    await this.$nextTick()

    if (this.discussionPostUuid) {
      this.fetchPost()
    }

    const uri = new URI()
    const queryString = uri.query(true)

    if (queryString.hasOwnProperty('category')) {
      this.form.category.uuid = queryString.category
    }
  },
  methods: {
    ...mapActions([
      'discussionGetPost',
      'discussionCreatePost',
      'discussionUpdatePost',
    ]),
    fetchPost() {
      this.discussionGetPost({
        postUuid: this.discussionPostUuid,
        params: {
          include: 'category,folder.documents',
        },
      }).then(() => {
        this.form.exists = true
        this.form.uuid = this.post.uuid
        this.form.title = this.post.attributes.title
        this.form.body = this.post.attributes.body
        this.form.category.uuid = this.post.category.uuid
        this.postLoaded = true
        this.form.existingDocuments = _.get(this.post, 'folder.documents.data', [])
      })
    },
    send() {
      this.form.startProcessing()

      if (this.form.exists) {
        this.discussionUpdatePost(this.form)
          .then((response) => {
            this.redirectUri = this.$urlGenerator.active(`discussions/${response.data.category.attributes.slug}/${response.data.attributes.slug}`)

            this.$refs.documents.upload(this.$urlGenerator.active(`api/v1/discussions/posts/${response.data.uuid}/upload`))
          })
      } else {
        this.discussionCreatePost(this.form)
          .then((response) => {
            this.redirectUri = this.$urlGenerator.active(`discussions/${response.data.category.attributes.slug}/${response.data.attributes.slug}`)

            this.$refs.documents.upload(this.$urlGenerator.active(`api/v1/discussions/posts/${response.data.uuid}/upload`))
          })
      }
    },
    redirect() {
      window.location.replace(this.redirectUri)
    },
  },
}
</script>
